<div bsModal
     #editLocalWarehouseModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="editLocalWarehouseModal"
     aria-hidden="true" [config]="{backdrop: 'static', keyboard: false}">

    <div class="modal-dialog modal-lg m-w-80" *ngIf="active">
        <div class="modal-content"  [formGroup]="warehouseForm">

            <div class="modal-header">
                <h4 class="modal-title">
                    <ng-container *ngIf="isSelectingArticles; else editLocalWarehouse">
                        {{ "SelectingArticles" | localize }}
                    </ng-container>
                    <ng-template #editLocalWarehouse>
                        {{ "EditLocalWarehouse" | localize }}
                    </ng-template>
                </h4>
                <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')" [disabled]="saving">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <div class="container">
                    <div class="row">
                        <div class="form-group col-12 col-lg-12 col-sm-12">
                            <label for="title">
                                <span translation="Title" source=""></span>
                            </label>
                            <input id="title"
                                   type="text"
                                   name="title"
                                   formControlName="title"
                                   readonly
                                   class="form-control"
                                   maxlength="64">
                        </div>
                        <div class="form-group col-12 col-lg-12 col-sm-12">
                            <label for="articleCode">
                                <span translation="Code" source=""></span>
                            </label>
                            <input id="articleCode"
                                   type="text"
                                   readonly
                                   name="articleCode"
                                   class="form-control"
                                   formControlName="articleCode"
                                   required
                                   maxlength="64">
                        </div>

                        <ng-container *ngIf="isAddMode; else table">

                            <div class="col-12 mb-4">
                                <div class="row card px-2 p-mx-auto">
                                    <div class="col-12 col-lg-12 col-sm-12">
                                        <h5 class="mb-2">{{'Axilla.FieldAgent.LocalWarehouse.CreateNewSpecification'| localize}}</h5>
                                    </div>

                                    <div class="col-12" [formGroup]="newRowForm">
                                        <div class="row">
                                            <div class="form-group col-12 col-lg-6 col-sm-12">
                                                <label for="articleCode">
                                                    {{'Axilla.FieldAgent.LocalWarehouse.THT'| localize}}
                                                </label>
                                                <p-calendar class="w-100"
                                                            formControlName="tht"
                                                            dateFormat="dd-mm-yy" placeholder="Select THT"></p-calendar>
                                            </div>

                                            <div class="form-group col-12 col-lg-6 col-sm-12">
                                                <label for="articleCode">
                                                    {{'Axilla.FieldAgent.LocalWarehouse.BatchNumber'| localize}}
                                                </label>
                                                <input class="w-100"  pInputText
                                                       formControlName="batchNumber"
                                                       placeholder="Enter Batch Number">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #table>
                            <div class="form-group col-12 col-md-12">
                                <app-manage-local-warehouse-items #manageLocalWarehouseItems
                                                                  (addNew)="onAddNew($event)"
                                                                  (rowSelect)="onRowToggle($event)"
                                                                  (rowUnselect)="onRowToggle($event)"
                                                                  [article]="article"></app-manage-local-warehouse-items>
                            </div>
                        </ng-template>

                        <div class="container">
                            <div class="overlay" *ngIf="!isAddMode && !isRowSelected"></div>

                            <div class="row">
                                <div class="form-group col-12 col-md-4">
                                    <label for="currentAmount">
                                        <span translation="CurrentAmount" source=""></span>
                                    </label>
                                    <p-inputNumber id="currentAmount"
                                                   formControlName="currentAmount"
                                                   class="w-100"
                                                   [readonly]="true"
                                                   [inputStyleClass]="'boxed'"
                                                   [min]="0"></p-inputNumber>

                                    <validation-messages [formCtrl]="warehouseForm.controls.currentAmount"></validation-messages>
                                </div>
                                <div class="form-group col-12 col-md-4 d-flex align-items-center">
                                    <app-universal-counter #universalCounter
                                                           class="w-100"
                                                           [customClass]="'round big'"
                                                           [mode]="'horizontal'"
                                                           (onChangeCounterWithValue)="onChangeCounter($event)"
                                                           [isAlowNegative]="true"
                                                           [article]="article"
                                                           [showAdd]="false"></app-universal-counter>
                                </div>
                                <div class="form-group col-12 col-md-4">
                                    <label for="newAmount">
                                        <span translation="NewAmount" source=""></span>
                                    </label>
                                    <p-inputNumber id="newAmount"
                                                   formControlName="newAmount"
                                                   class="w-100"
                                                   [inputStyleClass]="'boxed'"
                                                   [min]="0"></p-inputNumber>

                                    <validation-messages [formCtrl]="warehouseForm.controls.newAmount"></validation-messages>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12 mb-0">
                            <label for="reason">
                                <span translation="Reason" source=""></span> *
                            </label>
                            <textarea id="reason"
                                      formControlName="reason"
                                      rows="4"
                                      style="resize: none;"
                                      class="form-control"></textarea>

                            <validation-messages [formCtrl]="warehouseForm.controls.reason"></validation-messages>
                        </div>

                        <div class="col-12 mt-4 mb-0 double-confirmation" *ngIf="doubleConfirmation">
                            {{ 'Axilla.FieldAgent.MLW.DoubleConfirmation' | localize }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button"
                        [disabled]="saving"
                        class="btn btn-secondary"
                        (click)="close()">
                    <span translation="Cancel" source=""></span>
                </button>

                <button class="btn btn-primary"
                        *ngIf="isAddMode"
                        (click)="goBack()">
                    <i class="fa fa-arrow-left"></i>
                    {{ 'Back'| localize }}
                </button>

                <button class="btn btn-primary"
                        [ngClass]="{'double-confirmation-btn':doubleConfirmation && isApplying}"
                        (click)="onApply()"
                        [disabled]="this.warehouseForm.invalid || this.newRowForm.invalid || saving">
                    <i class="fa fa-check"></i>

                    {{ 'Apply'| localize }}
                </button>

                <button type="submit"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                        class="btn btn-primary"
                        [ngClass]="{'double-confirmation-btn':doubleConfirmation && isSaveAndClose}"
                        (click)="onSave()"
                        [disabled]="this.warehouseForm.invalid || this.newRowForm.invalid || saving ">
                    <i class="fa fa-save"></i>
                    <span translation="SaveAndClose" source=""></span>
                </button>

            </div>
        </div>
    </div>
</div>
